import { Component, OnInit,HostListener } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { HelperService } from '../helper.service';
import { Http, Response,Headers } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
class Data {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.css'],
  providers: [HelperService] 
})


export class StudentsComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  parent_id=0;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas: Data[] = [];
  dtElement: DataTableDirective;
  student_list:any=[];
  syllabus_list:any=[];
  grade_list:any=[];
  subscription_list:any=[];
syllabus_grade_id;

  selected_grade;
  selected_syllabus;
  selected_subscription;

  sgid;
  subscriptions;
  list=true;
  edit=false;
  add=false;
  icon_action='addClick';
  icon=this.helper.add_icon;
  student_username;
  student_id;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
   constructor(private activatedRoute: ActivatedRoute,private http:Http, private helper:HelperService,private snackbar: MatSnackBar,private router: Router) { }
  
  ngOnInit() {
  	 this.activatedRoute.params.subscribe((params: Params) => {
        this.parent_id = params['id'];
    
      });

    this.http.get(this.helper.base_url+'http/get/students/'+this.parent_id,{ headers: this.headers })
     
      .subscribe(data => {
       
        this.datas = JSON.parse(data['_body']);
       
      });
        this.http.get(this.helper.base_url+'http/get/syllabus',{ headers: this.headers })
      .map(this.extractData)
      .subscribe(syllabuses => {
       
        this.syllabus_list = syllabuses;
        
      });
  }
   syllabusChange(event:any){
    let syllabus_id=event.target.value;
   
	this.selected_subscription=[];
	this.syllabus_grade_id=[];
    this.subscription_list=[];
   this.subscriptions=[];
    this.http.get(this.helper.base_url+'http/get/grade/'+syllabus_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.grade_list = data;
         
       
      });

  }
  gradeChange(event:any){

    this.sgid=event.target[event.target.selectedIndex].dataset.sgid;
    this.selected_grade;
	
	this.selected_subscription;
	this.syllabus_grade_id;
 	 this.subscriptions=[];
    this.subscription_list=[];
    this.http.get(this.helper.base_url+'http/get/subscription/'+this.sgid,{ headers: this.headers })
    .map(this.extractData)
    .subscribe(data => {
      this.subscriptions = data;
      
    });

  }
     editClick(data){
this.student_username=data.name;
this.student_id=data.id;
if(data.syllabus_grade.length!=0){
  this.selected_grade=data.syllabus_grade[0].grade_id;
this.selected_syllabus=data.syllabus_grade[0].syllabus_id;
}

this.selected_subscription=data.subscriptions;
this.syllabus_grade_id=data.syllabus_grade_id;

this.http.get(this.helper.base_url+'http/get/students/'+this.parent_id,{ headers: this.headers })
     
      .subscribe(data => {
       
        this.student_list = JSON.parse(data['_body']);
       
      });


this.http.get(this.helper.base_url+'http/get/syllabus',{ headers: this.headers })
    .map(this.extractData)
    .subscribe(syllabuses => {
       
      this.syllabus_list = syllabuses;
      this.http.get(this.helper.base_url+'http/get/grade/'+data.syllabus_grade[0].syllabus_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.grade_list = data;
        this.http.get(this.helper.base_url+'http/get/subscription/'+this.syllabus_grade_id,{ headers: this.headers })
        .map(this.extractData)
        .subscribe(data => {
          this.subscriptions = data;    
          
        });
      });
     
    });

    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
   
  
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
   addClick(e){
  
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
   update_form(updateForm: NgForm){
  let body = new FormData();

  body.append('subscription[]', updateForm.value.subscription);
 

   this.http.post(this.helper.base_url+'http/update/student/subscription/'+this.student_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
     let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'Student subscription updated successfully') ;
    }else{
       this.listClick(null) ;
      this.error_refresh(false,data.message) ;
    }
    
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 add_form(addForm: NgForm){
  let body = new FormData();
  body.append('subscription[]', addForm.value.subscription);
  body.append('username', addForm.value.username);
  body.append('syllabus_grade_id',this.sgid );
   this.http.post(this.helper.base_url+'http/add/student/'+this.parent_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
     let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'Student subscription added successfully') ;
    }else{
       this.listClick(null) ;
      this.error_refresh(false,data.message) ;
    }
    
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }

  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }
  backbtn(){
    window.history.back();
  }
   refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/student/"+this.parent_id]));
  
      
 }
  error_refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/student/"+this.parent_id]));
  
      
 }

}




// WEBPACK FOOTER //
// ./src/app/students/students.component.ts